/**
 * Discount component
 * @returns <Discount />
 */

const Discount = ({ text }) => {
    return (
        <div className="discount">
            <img src={`${window._env_.STATIC_HOST}/static/website/images/icon-discount.svg`} alt="" />

            <p>{text}</p>
        </div>
    )
}

export default Discount
